import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AccountingSubAccountEnum } from '@zaoblako/shared/modules/catalog/enums/accounting-sub-account.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string represenations of {@link AccountingSubAccountEnum} enumeration values */
export const AccountingSubAccountEnumI18n: EnumI18nInterface<AccountingSubAccountEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AccountingSubAccountEnum.DEBIT_TURNOVER]: 'Обороты дебет',
    [AccountingSubAccountEnum.CREDIT_TURNOVER]: 'Обороты кредит',
    [AccountingSubAccountEnum.BALANCE_TURNOVER]: 'Обороты сальдо',
    [AccountingSubAccountEnum.INITIAL_BALANCE]: 'Сальдо на начало периода',
  },
  [I18nLocalesEnum.EN_US]: {
    [AccountingSubAccountEnum.DEBIT_TURNOVER]: 'Debit turnover',
    [AccountingSubAccountEnum.CREDIT_TURNOVER]: 'Credit turnover',
    [AccountingSubAccountEnum.BALANCE_TURNOVER]: 'Balance turnover',
    [AccountingSubAccountEnum.INITIAL_BALANCE]: 'Сальдо на начало периода',
  },
};
